import React, { useState } from "react";
import "../styles/InterviewInvites.css";
// import Female from"../assets/female.png"
import { MdShare , MdDelete} from "react-icons/md";
export default function InterviewInvites() {
    const [selected, setSelected] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    // const [isApplied,setIsApplied]=useState(false)
    const isMobile = window.innerWidth < 768;

  const [invites,setInvites] = useState([
    {
      id: 1,
      company: "TCS",
      logo: "/logos/tcs.png",
      jobTitle: "Frontend Developer",
      location: "Chennai",
      salary: "₹6 -8 LPA",
      experience: "2 - 4 Years",
      description: "React developer required for UI projects.",
      education: "B.Tech / MCA",
      vacancy: "5",
      employmentType: "Full Time",
      roles: "Develop UI using React.",
      evaluation: "Technical + HR",
      skills: "React, HTML, CSS",
      aboutCompany: "India's largest IT company",
      meeting: {
        date: "15 Jan 2025",
        time: "10:30 AM",
        location: "Virtual",
        link: "https://meet.google.com/abc",
      },
    },
    {
      id: 2,
      company: "Infosys",
    //   logo: Female,
      logo:"",
      jobTitle: "Backend Developer",
      location: "Bangalore",
      salary: "₹5-7 LPA",
      experience: "3 - 5 Years",
      description: "FastAPI developer role.",
      education: "B.Tech",
      vacancy: "3",
      employmentType: "Full Time",
      roles: "API Development",
      evaluation: "Technical Round",
      skills: "Python, FastAPI",
      aboutCompany: "Global IT Services",
      meeting: {
        date: "18 Jan 2025",
        time: "11:00 AM",
        location: "Office",
        link: "https://meet.google.com/abcd",
      },
    },  
  ]);

  const handleDelete = (id) => {
    setInvites((prev) => prev.filter((item) => item.id !== id));
  
    // If deleted job is currently selected → clear right panel
    if (selected?.id === id) {
      setSelected(null);
      if (isMobile) setShowDetails(false); 
    }
  };
  
  // const handleApply = () =>{
  //      setIsApplied(true)
  // }

  return (
    <div className="invite-container">
      {/* LEFT LIST */}
      {(!isMobile || !showDetails) && (
      <div className="invite-list">

        <h2>Interview Invites</h2>

        {invites.map((item) => (
          <div
            key={item.id}
            className="invite-card"
            onClick={() => {setSelected(item); 
                if (isMobile) setShowDetails(true);
            }}
          >
           <img src={item.logo} alt="" className="company-logo"/>


            <div className="info">
              <h3>{item.jobTitle}</h3>
              <p>{item.company}</p>
              <p>{item.location}</p>
              {item.salary && <p>{item.salary}</p>}
              {item.experience && <p>{item.experience}</p>}

            </div>
          </div>
        ))}
      </div> )}

      {/* RIGHT DETAILS */}
      {(!isMobile || showDetails) && (
     <div className="invite-details">

        {selected ? (
          <>
            <div className="details-header">
              <div className="details-left">
              {isMobile && (
                    <button className="mobile-back" onClick={() => setShowDetails(false)}>
                        ← 
                    </button>
                    )}

                <img src={selected.logo} alt="" className="company-logo" />
                <div className="right-details">
                <h3 style={{color:"#222"}}>{selected.jobTitle} </h3>
                <p>{selected.company}</p>
                <p>{selected.location}</p>
                {selected.salary && <p>{selected.salary}</p>}
                {selected.experience && <p>{selected.experience}</p>}

                </div>
              </div>

              <div className="icons">
                <button className="icon-btn"><MdShare style={{color:"#4169e1"}}/></button>
                <button className="icon-btn"onClick={() => handleDelete(selected.id)}><MdDelete style={{color:"4169e1"}}/></button>
              </div>
            </div>

            <div className="details-section">
              <h4>Job Description</h4>
              <p>{selected.description}</p>

              <h4>Education</h4>
              <p>{selected.education}</p>

              {selected.vacancy && (
                  <>
                    <h4>Vacancy</h4>
                    <p>{selected.vacancy}</p>
                  </>
                )}


              <h4>Employment Type</h4>
              <p>{selected.employmentType}</p>

              <h4>Roles & Responsibilities</h4>
              <p>{selected.roles}</p>

              {selected.evaluation && (
                  <>
                    <h4>Evaluation Process</h4>
                    <p>{selected.evaluation}</p>
                  </>
                )}


              <h4>Skills Required</h4>
              <p>{selected.skills}</p>

              {selected.aboutCompany && (
                    <>
                      <h4>About Company</h4>
                      <p>{selected.aboutCompany}</p>
                    </>
                  )}


               {/* MEETING SECTION */}
               {selected.meeting && (
                <div className="meeting-box">
                  <h3>Meeting Invite</h3>

                  {selected.meeting.date && (
                    <p><b>Date:</b> {selected.meeting.date}</p>
                  )}

                  {selected.meeting.time && (
                    <p><b>Time:</b> {selected.meeting.time}</p>
                  )}

                  {selected.meeting.location && (
                    <p><b>Location:</b> {selected.meeting.location}</p>
                  )}

                  {selected.meeting.link && (
                    <p>
                      <b>Meeting Link:</b>
                      <a href={selected.meeting.link} target="_blank" rel="noreferrer">
                        {selected.meeting.link}
                      </a>
                    </p>
                  )}
                </div>
              )}

            </div>

           

            {/* ACTION BUTTONS */}
            <div className="action-buttonss">
              <button className="reject" >Not Interested</button>
              <button className="apply" >Apply</button>

              {/* onClick={handleApply} disabled={isApplied}>{isApplied ? "Applied" :"Apply"} */}
            </div>
          </>
        ) : (
          <p className="select-msg">Select an invite to view details</p>
        )}
      </div>)}
    </div>
  );
}
